/* eslint-disable */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PropTypes from 'prop-types';
import { getJson } from 'session';

import { Acl } from 'modules/common/components/Acl'

import ProfileInformation from './ProfileInformation'
import CovidQuestionnaires from './CovidQuestionnaires'

import * as action from '../action';
import * as c from '../constant';

function Covid19Content({
  clearRegistration,
  isLoading,
  match,
  // add this later for ACL
  permissions,

  registrationInfo,
  showRegistration
}) {
  const selectedRegistration = match.params.id;
  
  const updateData = () => {
    showRegistration(selectedRegistration);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedRegistration)) {
      updateData();
    }
    return () => {
      clearRegistration();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedRegistration)) {
      updateData();
    }
  }, [selectedRegistration]);

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="pt-3 px-3" style={{ fontSize: '24px' }}>
          <strong>{_.get(registrationInfo, 'attributes.full_name')}</strong>
        </div>
        <div className="right-section-content2">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <Tabs>
                    <TabList>
                      <Tab>Profile</Tab>
                      <Tab>Covid Questions</Tab>
                      {/* <Tab>Permit</Tab> */}
                    </TabList>
                    <TabPanel>
                      <ProfileInformation
                        registrationInfo={registrationInfo}
                      />
                    </TabPanel>
                    {/* Covid Questions */}
                    <TabPanel>
                      <CovidQuestionnaires registrationInfo={registrationInfo}/>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Covid19Content.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  clearRegistration: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,

  permissions: PropTypes.instanceOf(Object).isRequired,

  registrationInfo: PropTypes.instanceOf(Object).isRequired,
  showRegistration: PropTypes.instanceOf(Function).isRequired
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  registrationInfo: _.get(api, `${c.SHOW_REGISTRATION}.item`) || {},
  showRegistration: _.get(api, `${c.SHOW_REGISTRATION}`) || {},
  
  isLoading:  api.loading.indexOf(c.SHOW_REGISTRATION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(Covid19Content);